// Logo URL constant for email templates
// Points to the logo stored in Firebase Storage

export const LOGO_URL = 'https://firebasestorage.googleapis.com/v0/b/roadyleiria-6789e.firebasestorage.app/o/logo%2Flogo.png?alt=media';

// Legacy export for backward compatibility (deprecated - use LOGO_URL instead)
export const LOGO_BASE64 = LOGO_URL;
